import React, { useState } from 'react';
import { FaBars, FaTimes, FaGithub, FaLinkedin } from 'react-icons/fa';
import { HiOutlineMail } from 'react-icons/hi';
import { BsFillPersonLinesFill } from 'react-icons/bs';
import Logo from '../assets/images/Logo.svg';
import { Link } from 'react-scroll';
import CV from '../assets/images/cv.pdf';

const Navbar = () => {
  const [nav, SetNav] = useState(false);

  const handlerClick = () => SetNav(!nav);

  return (
    <div className="fixed w-full h-[80px] flex justify-between items-center px-4 bg-[#0a192f] text-gray-300 z-[100]  ">
      <div>
        <img src={Logo} alt="logo" className="relative z-30" />
      </div>

      {/*menu*/}

      <ul className="hidden md:flex ">
        <li className="hover:text-[#5a9dd9] hover:scale-[1.2] duration-300 cursor-pointer">
          <Link to="home" smooth={true} duration={500}>
            Home
          </Link>
        </li>
        <li className="hover:text-[#5a9dd9] hover:scale-[1.2] duration-300 cursor-pointer">
          <Link to="about" smooth={true} duration={500} offset={40}>
            About
          </Link>
        </li>
        <li className="hover:text-[#5a9dd9] hover:scale-[1.2] duration-300 cursor-pointer">
          <Link to="skills" smooth={true} duration={500} offset={40}>
            Skills
          </Link>
        </li>
        <li className="hover:text-[#5a9dd9] hover:scale-[1.2] duration-300 cursor-pointer">
          <Link to="projects" smooth={true} duration={500} offset={-40}>
            Projects
          </Link>
        </li>
        <li className="hover:text-[#5a9dd9] hover:scale-[1.2] duration-300 cursor-pointer">
          <Link to="contact" smooth={true} duration={500}>
            Contact
          </Link>
        </li>
      </ul>

      {/*hamburger*/}
      <div className="md:hidden relative z-30" onClick={handlerClick}>
        {!nav ? <FaBars /> : <FaTimes />}
      </div>

      {/*mobil menu*/}

      <ul
        className={
          !nav
            ? 'hidden'
            : 'absolute top-0 left-0 w-full h-screen flex flex-col justify-center items-center bg-[#0a192f] z-20 '
        }
      >
        <li className="py-6 text-3xl hover:text-[#5a9dd9] hover:scale-[1.2] duration-300">
          <Link to="home" smooth={true} duration={500} onClick={handlerClick}>
            Home
          </Link>
        </li>
        <li className="py-6 text-3xl hover:text-[#5a9dd9] hover:scale-[1.2] duration-300">
          <Link
            to="about"
            smooth={true}
            duration={500}
            offset={-80}
            onClick={handlerClick}
          >
            About
          </Link>
        </li>
        <li className="py-6 text-3xl hover:text-[#5a9dd9] hover:scale-[1.2] duration-300">
          <Link to="skills" smooth={true} duration={500} onClick={handlerClick}>
            Skills
          </Link>
        </li>
        <li className="py-6 text-3xl hover:text-[#5a9dd9] hover:scale-[1.2] duration-300">
          <Link
            to="projects"
            smooth={true}
            duration={500}
            onClick={handlerClick}
            offset={-80}
          >
            Projects
          </Link>
        </li>
        <li className="py-6 text-3xl hover:text-[#5a9dd9] hover:scale-[1.2] duration-300">
          <Link
            to="contact"
            smooth={true}
            duration={500}
            onClick={handlerClick}
            offset={-50}
          >
            Contact
          </Link>
        </li>
      </ul>

      {/*social icons*/}
      <div className="hidden lg:flex fixed flex-col top-[35%] left-0 ">
        <ul>
          <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-blue-600">
            <a
              className="w-full flex justify-between  items-center text-gray-300"
              href="https://www.linkedin.com/in/ak%C4%B1n-akg%C3%BCne%C5%9F-86ab17219/"
              target="_blank"
              rel="noreferrer"
            >
              Linkedin <FaLinkedin size={30} />
            </a>
          </li>
          <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#333333]">
            <a
              className="w-full flex justify-between  items-center text-gray-300"
              href="https://github.com/akinakgunes12"
              target="_blank"
              rel="noreferrer"
            >
              Github <FaGithub size={30} />
            </a>
          </li>
          <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#6fc2b0]">
            <a
              className="w-full flex justify-between  items-center text-gray-300"
              href="mailto:akinakgunes12@gmail.com"
            >
              Email <HiOutlineMail size={30} />
            </a>
          </li>
          <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#565f69]">
            <a
              className="w-full flex justify-between  items-center text-gray-300"
              href={CV}
              target="_blank"
              rel="noreferrer"
            >
              Resume <BsFillPersonLinesFill size={30} />
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
